import { ActionContext, ActionTree, GetterTree } from "vuex";
import { Buhin, SubBuhinCategory, BuhinDetail } from "@/model/Buhin";
import { BuhinCategory } from "@/model/Buhin";

const actions: ActionTree<any, any> = {
  setState({ commit }: ActionContext<any, any>, payload: any): void {
    commit("setState", payload);
  },
  clearState({ commit }: ActionContext<any, any>): void {
    commit("clearState");
  }
};

const mutations = {
  setState(state: any, payload: Buhin[]) {
    state.buhin = payload;
    const index = state.buhin.length - 1;
    state.buhin[index].items.forEach((cate: BuhinCategory) => {
      cate.items.forEach((subCate: SubBuhinCategory) => {
        subCate.items = subCate.items.map((buhin: BuhinDetail) => {
          let buhin1 = { ...buhin };
          buhin.buhinPriceZk = buhin.kingakuZk;
          buhin.buhinPriceZn = buhin.kingakuZn;
          return buhin1;
        });
      });
    });
  },
  clearState(state: any) {
    Object.assign(state, { buhin: [] });
  }
};

const getters: GetterTree<any, any> = {
  buhin(state: any) {
    return state.buhin;
  }
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: { buhin: [] },
  getters,
  actions,
  mutations
};
